import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider as AntdConfigProvider } from 'antd';
import enUS from 'antd/es/locale/en_US';
import { TrpcProvider } from './trpc/Provider';
import { NetworkStatusProvider } from './context/NetworkStatusContext';
import { ConfigProvider } from './context/ConfigProvider';
import { PostHogProvider } from './context/PostHogContext';
import { AuthProvider } from './context/AuthContext';
import { TabsProvider } from './context/TabsContext';
import { TurnstileProvider } from './context/TurnstileContext';
import { PreferencesProvider } from './context/PreferencesContext';
import { FormDirtyProvider } from './context/FormDirtyContext';
import { PermissionOverlayProvider } from './context/PermissionOverlayContext';
import { ChunkErrorBoundary } from './components/ChunkErrorBoundary';
import { RouteTracker, AnalyticsUserSync } from './components/Analytics';
import { PermissionOverlayIndicator } from './components/PermissionOverlay';
import { App } from './App';
import './global.less';
import './global'; // PWA/serviceWorker setup

// Import dayjs configuration with all required plugins
import './utils/dayjs-config';
// Test dayjs plugins in development
import './utils/test-dayjs';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* ConfigProvider loads env config before rendering the app */}
    <ConfigProvider>
      {/* PostHogProvider initializes analytics with self-hosted instance */}
      <PostHogProvider>
        <NetworkStatusProvider>
        <TrpcProvider>
          <BrowserRouter>
            <AntdConfigProvider locale={enUS}>
              <AuthProvider>
                {/* PermissionOverlayProvider enables the developer tool for visualizing permissions */}
                <PermissionOverlayProvider>
                  {/* AnalyticsUserSync identifies users with PostHog on auth changes */}
                  <AnalyticsUserSync />
                  {/* RouteTracker automatically tracks page views */}
                  <RouteTracker />
                  <TurnstileProvider>
                    <PreferencesProvider>
                      <TabsProvider>
                      {/* FormDirtyProvider tracks unsaved form state for ChunkErrorBoundary */}
                      <FormDirtyProvider>
                        {/* ChunkErrorBoundary catches dynamic import failures after deployments */}
                        <ChunkErrorBoundary>
                          <App />
                          {/* PermissionOverlayIndicator shows when overlay is active */}
                          <PermissionOverlayIndicator />
                        </ChunkErrorBoundary>
                      </FormDirtyProvider>
                      </TabsProvider>
                    </PreferencesProvider>
                  </TurnstileProvider>
                </PermissionOverlayProvider>
              </AuthProvider>
            </AntdConfigProvider>
          </BrowserRouter>
        </TrpcProvider>
        </NetworkStatusProvider>
      </PostHogProvider>
    </ConfigProvider>
  </React.StrictMode>
);
